import { render, staticRenderFns } from "./BaseBoltIcon.vue?vue&type=template&id=59b60e77"
import script from "./BaseBoltIcon.vue?vue&type=script&lang=js"
export * from "./BaseBoltIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports